import { Static, Type } from '@sinclair/typebox';
import { MOBILE_SEMVER_PATTERN as SEMVER_PATTERN } from './mobile_app.version';

const MobileAppPlatformVersionSchema = Type.Object({
  // En dessous de `min` : écran natif bloquant « Mise à jour requise ».
  min: Type.String({ pattern: SEMVER_PATTERN }),
  // En dessous de `recommended` : MAJ conseillée mais non bloquante (réservé
  // pour une future incitation douce — le client n'en fait rien aujourd'hui).
  recommended: Type.String({ pattern: SEMVER_PATTERN }),
  // Absent tant que l'app n'est pas publiée sur le store de la plateforme
  // (l'URL App Store exige l'id numérique attribué à la publication).
  store_url: Type.Optional(Type.String()),
});

export const MobileAppMinVersionResponseSchema = Type.Object({
  ios: MobileAppPlatformVersionSchema,
  android: MobileAppPlatformVersionSchema,
});

export type MobileAppMinVersionResponse = Static<typeof MobileAppMinVersionResponseSchema>;
export type MobileAppPlatformVersion = Static<typeof MobileAppPlatformVersionSchema>;
